import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useMantineStyleNonce } from "./auth-service-tools199.js";
import { stylesToString } from "./auth-service-tools235.js";

function InlineStyles(props) {
  const nonce = useMantineStyleNonce();
  return /* @__PURE__ */jsxRuntimeExports.jsx("style", {
    "data-mantine-styles": "inline",
    nonce: nonce == null ? void 0 : nonce(),
    dangerouslySetInnerHTML: {
      __html: stylesToString(props)
    }
  });
}

export { InlineStyles };